export default "__VITE_ASSET__9ae4540c__"